import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-js';

import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import useCoinFlip from '../useCoinFlip';
import {
  Coin,
  CoinContainer,
  CoinInside,
  Container,
  Heads,
  Tails,
} from './styles';

function CoinFlipSimple({ data, styles }) {
  const boxRef = useRef();

  const fontFamilyHeads = FONT_FAMILY[styles?.heads?.font || 'notoSans'];
  const fontFamilyTails = FONT_FAMILY[styles?.tails?.font || 'notoSans'];

  useCoinFlip(data, boxRef);

  return (
    <>
      <FontFamilyHeader family={fontFamilyHeads} />
      <FontFamilyHeader family={fontFamilyTails} />
      <Container>
        <CoinContainer>
          <CoinInside ref={boxRef}>
            <Coin className="heads">
              <Heads
                borderColor={styles?.heads?.border}
                style={{
                  background: styles?.heads?.background,
                  color: styles?.heads?.color,
                  fontFamily: fontFamilyHeads?.family,
                  fontSize: styles?.heads?.size,
                  letterSpacing: styles?.heads?.letterSpacing,
                  lineHeight: styles?.heads?.size
                    ? `${styles?.heads?.size}px`
                    : undefined,
                }}
              >
                {i18n.t('common.heads')}
              </Heads>
            </Coin>
            <Coin className="tails">
              <Tails
                borderColor={styles?.tails?.border}
                style={{
                  background: styles?.tails?.background,
                  color: styles?.tails?.color,
                  fontFamily: fontFamilyTails?.family,
                  fontSize: styles?.tails?.size,
                  letterSpacing: styles?.tails?.letterSpacing,
                  lineHeight: styles?.tails?.size
                    ? `${styles?.tails?.size}px`
                    : undefined,
                }}
              >
                {i18n.t('common.tails')}
              </Tails>
            </Coin>
          </CoinInside>
        </CoinContainer>
      </Container>
    </>
  );
}

CoinFlipSimple.propTypes = {
  data: PropTypes.shape({
    mustSpin: PropTypes.bool,
    winner: PropTypes.string,
  }),
  styles: PropTypes.shape({
    heads: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
    tails: PropTypes.shape({
      background: PropTypes.string,
      border: PropTypes.string,
      color: PropTypes.string,
      font: PropTypes.string,
      letterSpacing: PropTypes.number,
      size: PropTypes.number,
    }),
  }),
};

CoinFlipSimple.defaultProps = {
  data: {
    mustSpin: false,
    winner: 'heads',
  },
  styles: {
    heads: {
      background: '#675ce7',
      border: '#ffffff',
      color: '#ffffff',
      font: 'notoSans',
      letterSpacing: 0,
      size: 30,
    },
    tails: {
      background: '#000000',
      border: '#ffffff',
      color: '#ffffff',
      font: 'notoSans',
      letterSpacing: 0,
      size: 30,
    },
  },
};

export default CoinFlipSimple;
